// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AliwangwangFilledSvg from "@ant-design/icons-svg/es/asn/AliwangwangFilled";
import AntdIcon from '../components/AntdIcon';

var AliwangwangFilled = function AliwangwangFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AliwangwangFilledSvg
  }));
};

AliwangwangFilled.displayName = 'AliwangwangFilled';
export default /*#__PURE__*/React.forwardRef(AliwangwangFilled);